export default "__VITE_ASSET__C5wKx2kc__"